import { hydrateRoot } from 'nordic/hydrate';

import { I18n, I18nProvider } from 'nordic/i18n';
import { AndesProvider } from '@andes/context';
import HubView, { ViewProps } from '../../pages/hub/view';
import UserDataWrapper from '../../components/user-data-context';
import { PageProvider } from '../../contexts/PageContext';
import { RebrandingProvider } from '../../contexts/RebrandingContext';

const props = window.__PRELOADED_STATE__ as ViewProps;

const i18n = new I18n({
  translations: props.translations,
});

hydrateRoot(document.getElementById('root-app')!,
  <AndesProvider locale={props.locale}>
    <RebrandingProvider appTheme={props.appTheme}>
      <PageProvider {...props.defaultProps}>
        <UserDataWrapper abuseScoring={props.hubInfo.abuse_scoring}>
          <I18nProvider i18n={i18n}>
            <HubView {...props} />
          </I18nProvider>
        </UserDataWrapper>
      </PageProvider>
    </RebrandingProvider>
  </AndesProvider>);
